const COUNTRY_LIST = [
    { code: 'IND', phone: '91' },
    { code: 'CHN', phone: '86' },
    { code: 'USA', phone: '1' },
    { code: 'IDN', phone: '62' },
    { code: 'PAK', phone: '92' },
    { code: 'BRA', phone: '55' },
    { code: 'NGA', phone: '234' },
    { code: 'BGD', phone: '880' },
    { code: 'RUS', phone: '7' },
    { code: 'MEX', phone: '52' },
    { code: 'JPN', phone: '81' },
    { code: 'ETH', phone: '251' },
    { code: 'PHL', phone: '63' },
    { code: 'EGY', phone: '20' },
    { code: 'VNM', phone: '84' },
    { code: 'COD', phone: '243' },
    { code: 'IRN', phone: '98' },
    { code: 'TUR', phone: '90' },
    { code: 'DEU', phone: '49' },
    { code: 'THA', phone: '66' },
    { code: 'FRA', phone: '33' },
    { code: 'GBR', phone: '44' },
    { code: 'TZA', phone: '255' },
    { code: 'ZAF', phone: '27' },
    { code: 'ITA', phone: '39' },
    { code: 'MMR', phone: '95' },
    { code: 'KEN', phone: '254' },
    { code: 'KOR', phone: '82' },
    { code: 'COL', phone: '57' },
    { code: 'ESP', phone: '34' },
    { code: 'UGA', phone: '256' },
    { code: 'ARG', phone: '54' },
    { code: 'SDN', phone: '249' },
    { code: 'DZA', phone: '213' },
    { code: 'UKR', phone: '380' },
    { code: 'IRQ', phone: '964' },
    { code: 'AFG', phone: '93' },
    { code: 'CAN', phone: '1' },
    { code: 'POL', phone: '48' },
    { code: 'MAR', phone: '212' },
    { code: 'SAU', phone: '966' },
    { code: 'UZB', phone: '998' },
    { code: 'AGO', phone: '244' },
    { code: 'PER', phone: '51' },
    { code: 'MYS', phone: '60' },
    { code: 'YEM', phone: '967' },
    { code: 'GHA', phone: '233' },
    { code: 'MOZ', phone: '258' },
    { code: 'NPL', phone: '977' },
    { code: 'MDG', phone: '261' },
    { code: 'VEN', phone: '58' },
    { code: 'CIV', phone: '225' },
    { code: 'CMR', phone: '237' },
    { code: 'PRK', phone: '850' },
    { code: 'AUS', phone: '61' },
    { code: 'NER', phone: '227' },
    { code: 'LKA', phone: '94' },
    { code: 'BFA', phone: '226' },
    { code: 'MLI', phone: '223' },
    { code: 'SYR', phone: '963' },
    { code: 'MWI', phone: '265' },
    { code: 'CHL', phone: '56' },
    { code: 'ZMB', phone: '260' },
    { code: 'ROU', phone: '40' },
    { code: 'KAZ', phone: '997' },
    { code: 'ECU', phone: '593' },
    { code: 'NLD', phone: '31' },
    { code: 'TCD', phone: '235' },
    { code: 'GTM', phone: '502' },
    { code: 'SOM', phone: '252' },
    { code: 'SEN', phone: '221' },
    { code: 'KHM', phone: '855' },
    { code: 'ZWE', phone: '263' },
    { code: 'GIN', phone: '224' },
    { code: 'RWA', phone: '250' },
    { code: 'BEN', phone: '229' },
    { code: 'BDI', phone: '257' },
    { code: 'TUN', phone: '216' },
    { code: 'BOL', phone: '591' },
    { code: 'BEL', phone: '32' },
    { code: 'HTI', phone: '509' },
    { code: 'CUB', phone: '53' },
    { code: 'JOR', phone: '962' },
    { code: 'DOM', phone: '1-809' },
    { code: 'SSD', phone: '211' },
    { code: 'GRC', phone: '30' },
    { code: 'CZE', phone: '420' },
    { code: 'SWE', phone: '46' },
    { code: 'PRT', phone: '351' },
    { code: 'TNW', phone: '886' },
    { code: 'HND', phone: '504' },
    { code: 'AZE', phone: '994' },
    { code: 'PNG', phone: '675' },
    { code: 'TJK', phone: '992' },
    { code: 'HUN', phone: '36' },
    { code: 'ARE', phone: '971' },
    { code: 'ISR', phone: '972' },
    { code: 'BLR', phone: '375' },
    { code: 'AUT', phone: '43' },
    { code: 'CHE', phone: '41' },
    { code: 'TGO', phone: '228' },
    { code: 'SLE', phone: '232' },
    { code: 'LAO', phone: '856' },
    { code: 'HKG', phone: '852' },
    { code: 'BGR', phone: '359' },
    { code: 'NIC', phone: '505' },
    { code: 'SRB', phone: '381' },
    { code: 'LBY', phone: '218' },
    { code: 'PRY', phone: '595' },
    { code: 'KGZ', phone: '996' },
    { code: 'TKM', phone: '993' },
    { code: 'SLV', phone: '503' },
    { code: 'DNK', phone: '45' },
    { code: 'COG', phone: '242' },
    { code: 'LBN', phone: '961' },
    { code: 'FIN', phone: '358' },
    { code: 'CAF', phone: '236' },
    { code: 'SGP', phone: '65' },
    { code: 'SVK', phone: '421' },
    { code: 'NOR', phone: '47' },
    { code: 'LBR', phone: '231' },
    { code: 'CRI', phone: '506' },
    { code: 'NZL', phone: '64' },
    { code: 'IRL', phone: '353' },
    { code: 'PSE', phone: '970' },
    { code: 'MRT', phone: '222' },
    { code: 'OMN', phone: '968' },
    { code: 'PAN', phone: '507' },
    { code: 'KWT', phone: '965' },
    { code: 'HRV', phone: '385' },
    { code: 'GEO', phone: '995' },
    { code: 'ERI', phone: '291' },
    { code: 'URY', phone: '598' },
    { code: 'MNG', phone: '976' },
    { code: 'BIH', phone: '387' },
    { code: 'PRI', phone: '1-787' },
    { code: 'JAM', phone: '1-876' },
    { code: 'ALB', phone: '355' },
    { code: 'LTU', phone: '370' },
    { code: 'ARM', phone: '374' },
    { code: 'QAT', phone: '974' },
    { code: 'GMB', phone: '220' },
    { code: 'MDA', phone: '373' },
    { code: 'BWA', phone: '267' },
    { code: 'NAM', phone: '264' },
    { code: 'GAB', phone: '241' },
    { code: 'LSO', phone: '266' },
    { code: 'SVN', phone: '386' },
    { code: 'MKD', phone: '389' },
    { code: 'GNB', phone: '245' },
    { code: 'LVA', phone: '371' },
    { code: 'GNQ', phone: '240' },
    { code: 'TTO', phone: '1-868' },
    { code: 'BHR', phone: '973' },
    { code: 'EST', phone: '372' },
    { code: 'TLS', phone: '670' },
    { code: 'MUS', phone: '230' },
    { code: 'CYP', phone: '357' },
    { code: 'SWZ', phone: '268' },
    { code: 'DJI', phone: '253' },
    { code: 'FJI', phone: '679' },
    { code: 'COM', phone: '269' },
    { code: 'GUY', phone: '592' },
    { code: 'BTN', phone: '975' },
    { code: 'SLB', phone: '677' },
    { code: 'REU', phone: '262' },
    { code: 'MAC', phone: '853' },
    { code: 'ESH', phone: '212' },
    { code: 'LUX', phone: '352' },
    { code: 'MNE', phone: '382' },
    { code: 'SUR', phone: '597' },
    { code: 'CPV', phone: '238' },
    { code: 'MDV', phone: '960' },
    { code: 'MLT', phone: '356' },
    { code: 'GLP', phone: '590' },
    { code: 'BRN', phone: '673' },
    { code: 'BHS', phone: '1-242' },
    { code: 'BLZ', phone: '501' },
    { code: 'MTQ', phone: '596' },
    { code: 'ISL', phone: '354' },
    { code: 'VUT', phone: '678' },
    { code: 'PYF', phone: '689' },
    { code: 'BRB', phone: '1-246' },
    { code: 'NCL', phone: '687' },
    { code: 'MYT', phone: '262' },
    { code: 'STP', phone: '239' },
    { code: 'WSM', phone: '685' },
    { code: 'GUF', phone: '594' },
    { code: 'LCA', phone: '1-758' },
    { code: 'GUM', phone: '1-671' },
    { code: 'CUW', phone: '599' },
    { code: 'KIR', phone: '686' },
    { code: 'GRD', phone: '1-473' },
    { code: 'FSM', phone: '691' },
    { code: 'ABW', phone: '297' },
    { code: 'TON', phone: '676' },
    { code: 'VIR', phone: '1-340' },
    { code: 'VCT', phone: '1-784' },
    { code: 'JEY', phone: '44-1534' },
    { code: 'SYC', phone: '248' },
    { code: 'ATG', phone: '1-268' },
    { code: 'IMN', phone: '44-1624' },
    { code: 'AND', phone: '376' },
    { code: 'DMA', phone: '1-767' },
    { code: 'CYM', phone: '1-345' },
    { code: 'GGY', phone: '44-1481' },
    { code: 'BMU', phone: '1-441' },
    { code: 'GRL', phone: '299' },
    { code: 'FRO', phone: '298' },
    { code: 'MNP', phone: '1-670' },
    { code: 'KNA', phone: '1-869' },
    { code: 'TCA', phone: '1-649' },
    { code: 'ASM', phone: '1-684' },
    { code: 'SXM', phone: '1-721' },
    { code: 'MHL', phone: '692' },
    { code: 'LIE', phone: '423' },
    { code: 'MCO', phone: '377' },
    { code: 'SMR', phone: '378' },
    { code: 'GIB', phone: '350' },
    { code: 'MAF', phone: '590' },
    { code: 'VGB', phone: '1-284' },
    { code: 'ALA', phone: '358' },
    { code: 'BES', phone: '599' },
    { code: 'AIA', phone: '1-264' },
    { code: 'PLW', phone: '680' },
    { code: 'WLF', phone: '681' },
    { code: 'NRU', phone: '674' },
    { code: 'TUV', phone: '688' },
    { code: 'COK', phone: '682' },
    { code: 'SHN', phone: '290' },
    { code: 'BLM', phone: '590' },
    { code: 'MSR', phone: '1-664' },
    { code: 'SPM', phone: '508' },
    { code: 'IOT', phone: '246' },
    { code: 'FLK', phone: '500' },
    { code: 'SJM', phone: '47' },
    { code: 'CXR', phone: '61' },
    { code: 'NIU', phone: '683' },
    { code: 'NFK', phone: '6723' },
    { code: 'TKL', phone: '690' },
    { code: 'VAT', phone: '39-6' },
    { code: 'CCK', phone: '61-891' },
    { code: 'PCN', phone: '649' },
    { code: 'SGS', phone: '500' },
    { code: 'XKX', phone: '383' },
];
export const COUNTRIES = COUNTRY_LIST;
